import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-064994ec"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "modern-form-container" };
const _hoisted_2 = { class: "language-selector" };
const _hoisted_3 = { class: "language-selected" };
const _hoisted_4 = { class: "language-flag" };
const _hoisted_5 = { class: "language-name" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("path", {
    d: "M6 9L12 15L18 9",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
}, null, -1));
const _hoisted_7 = [
    _hoisted_6
];
const _hoisted_8 = {
    key: 0,
    class: "language-options"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = { class: "language-flag" };
const _hoisted_11 = { class: "language-name" };
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("link", {
    rel: "preload",
    as: "document",
    href: "https://player.vimeo.com/video/1050807756?background=1&autoplay=1&loop=1&muted=1&playsinline=1&preload=auto"
}, null, -1));
const _hoisted_13 = { class: "video-background" };
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: "/assets/hit-online-hero-image.webp",
    alt: "Hit-Online Hero Background",
    class: "preload-image",
    loading: "eager"
}, null, -1));
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "video-overlay" }, null, -1));
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "logo-container" }, [
    /*#__PURE__*/ _createElementVNode("img", {
        src: "/assets/hit_online_logo_full.svg",
        alt: "Hit-Online Logo",
        class: "hit-logo",
        height: "150",
        width: "300"
    })
], -1));
const _hoisted_17 = { class: "form-card" };
const _hoisted_18 = { class: "card-header" };
const _hoisted_19 = { class: "form-title" };
const _hoisted_20 = { class: "form-subtitle" };
const _hoisted_21 = { class: "card-body" };
const _hoisted_22 = { class: "email-input-container" };
const _hoisted_23 = { class: "button-container" };
const _hoisted_24 = {
    key: 0,
    class: "banner-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_hit_input = _resolveComponent("hit-input");
    const _component_hit_button = _resolveComponent("hit-button");
    const _component_hit_form = _resolveComponent("hit-form");
    const _component_hit_banner = _resolveComponent("hit-banner");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
                class: "language-dropdown-container",
                onClick: _cache[0] || (_cache[0] =
                    //@ts-ignore
                    (...args) => (_ctx.toggleLanguageDropdown && _ctx.toggleLanguageDropdown(...args)))
            }, [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.getCurrentLanguageFlag()), 1),
                    _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.getCurrentLanguageName()), 1),
                    (_openBlock(), _createElementBlock("svg", {
                        class: _normalizeClass(["dropdown-icon", { rotated: _ctx.showLanguageDropdown }]),
                        width: "16",
                        height: "16",
                        viewBox: "0 0 24 24",
                        fill: "none"
                    }, _hoisted_7, 2))
                ]),
                (_ctx.showLanguageDropdown)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableLanguages, (lang) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: lang.code,
                                class: _normalizeClass(["language-option", { active: _ctx.$i18n.locale === lang.code }]),
                                onClick: _withModifiers(($event) => (_ctx.selectLanguage(lang.code)), ["stop"])
                            }, [
                                _createElementVNode("span", _hoisted_10, _toDisplayString(lang.flag), 1),
                                _createElementVNode("span", _hoisted_11, _toDisplayString(lang.name), 1)
                            ], 10, _hoisted_9));
                        }), 128))
                    ]))
                    : _createCommentVNode("", true)
            ])
        ]),
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("iframe", {
                class: "video-iframe",
                src: "https://player.vimeo.com/video/1050807756?background=1&autoplay=1&loop=1&muted=1&playsinline=1&preload=auto&quality=720p",
                frameborder: "0",
                allow: "fullscreen",
                allowfullscreen: "",
                loading: "eager",
                onLoad: _cache[1] || (_cache[1] =
                    //@ts-ignore
                    (...args) => (_ctx.onVideoReady && _ctx.onVideoReady(...args)))
            }, null, 32),
            _hoisted_15
        ]),
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
                _createElementVNode("h2", _hoisted_19, _toDisplayString(_ctx.t('admin-ui.register_email_form_explanation_title_1')), 1),
                _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.t('admin-ui.quote')), 1)
            ]),
            _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_hit_form, {
                    name: "RegisterEmailForm",
                    value: _ctx.objectFirstFormData,
                    validations: _ctx.validationsFirstForm,
                    "force-cancel-button-hidden": true,
                    "force-save-button-hidden": true
                }, {
                    default: _withCtx(({ formData, validationState, }) => [
                        _createElementVNode("div", _hoisted_22, [
                            _createVNode(_component_hit_input, {
                                name: "email",
                                class: "modern-email-input",
                                value: formData.email || '',
                                "validation-state": validationState.email,
                                label: _ctx.t('admin-ui.email'),
                                placeholder: 'nom@entreprise.com',
                                "inline-input": "",
                                onInput: _ctx.onChangeMail
                            }, null, 8, ["value", "validation-state", "label", "onInput"])
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                            _createVNode(_component_hit_button, {
                                color: "accent",
                                label: _ctx.t('admin-ui.lets_go'),
                                "suffix-icon": "send",
                                "icon-size": "sm",
                                class: "send-button",
                                disabled: !_ctx.emailCompleted,
                                onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.$emit('sendMail', { email: _ctx.objectFirstFormData.email })))
                            }, null, 8, ["label", "disabled"])
                        ])
                    ]),
                    _: 1
                }, 8, ["value", "validations"])
            ])
        ]),
        (_ctx.showBanner)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _createVNode(_component_hit_banner, {
                    "show-animation": _ctx.showAnimationBanner,
                    onClose: _cache[3] || (_cache[3] = ($event) => (_ctx.closeBanner()))
                }, {
                    "dynamic-content": _withCtx(() => [
                        _createElementVNode("h6", null, _toDisplayString(_ctx.textBanner), 1)
                    ]),
                    _: 1
                }, 8, ["show-animation"])
            ]))
            : _createCommentVNode("", true)
    ]));
}
